import { DeviceManagerRepositoryInterface } from "@/data/persistences/repositories/contracts/DeviceManagerRepositoryInterface";
import ApiService from "../../services/ApiService";
import { DeviceManagerMapper } from "@/data/persistences/mappers/DeviceManagerMapper";
import { Endpoints } from "../../misc";
import { DeviceManager } from "@/domain/entities/DeviceManager";

export class DeviceManagerApiRepository
  implements DeviceManagerRepositoryInterface {
    private service: ApiService
    private mapper: DeviceManagerMapper
  
    constructor(service: ApiService, mapper: DeviceManagerMapper) {
      this.service = service
      this.mapper = mapper
    }

    public async getList(): Promise<DeviceManager[]> {
      const resp = await this.service.invoke(
        'get',
        Endpoints.Route.DEVICE_MANAGER
      )
      return this.mapper.convertListDeviceManagerFromApi(resp)
    }

    public async logout(id: number): Promise<boolean> {
      const resp = await this.service.invoke(
        'post',
        `${Endpoints.Route.DEVICE_MANAGER}/${id}/logout`
      )
      return true
    }

  }